
    import {Component, Inject, Vue} from "vue-property-decorator";
    import Navbar from '@/components/layout/Navbar.vue';
    import Sidebar from '@/components/layout/SideBar.vue';
    import {Validator} from 'vee-validate';

    @Component({
        props: {
            title: String,
        },
        components: {
            Navbar,
            Sidebar,
        },
    })
    export default class Layout extends Vue {
        @Inject('$validator') public $validator!: Validator;
    }
